module.exports = __webpack_public_path__ + "img/success.3b013bb5.png";